// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"12b9f9e1","237":"33b56dd5","294":"16a54247","312":"6666a1e7","320":"27c8dfdc","356":"0ae5a8ec","643":"cc337d10","965":"50e19117"}[chunkId] + ".chunk.js";
};